<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center"> Histórico de Equipos Asignados </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="end" align="center">
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    class="transparent"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.equipoAsignado`]="{ item }">
                      <span v-if="Array.isArray(item.equipoAsignado)">
                        {{ item.equipoAsignado.map((eq) => eq.Equipo?.CatItem?.item || '').join(', ') }}
                      </span>
                      <span v-else>
                        {{ item.equipoAsignado }}
                      </span>
                    </template>
                    <template v-slot:[`item.file`]="{ item }">
                      <a v-if="item.file" :href="item.file" target="_blank">{{ item.file }}</a>
                      <span v-else>No hay archivo</span>
                    </template>
                    <template v-slot:[`item.acciones`]="{ item }">
                      <v-btn icon color="secondary" small v-if="item.file" :href="item.file" download>
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-text-box-search-outline"
                                @click="openListadoEquiposAsignadosDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Listado de Equipos Asignados</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import IconButton from '@/components/base/IconButton.vue'

export default {
  components: {
    IconButton,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Fecha de Solicitud', value: 'fechaSolicitud' },
        { text: 'Fecha de Asignación', value: 'fechaAsignacion' },
        { text: 'Folio de Resguardo', value: 'folioResguardo' },
        { text: 'Archivo', value: 'file' },
        { text: 'Equipo seleccionado', value: 'equipoAsignado' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('asignacionEquipo', {
      asignacionesEquipo: 'getAsignacionesEquipo',
    }),
    items() {
      return this.asignacionesEquipo.filter((a) => a.fk_idPersonal === this.id)
    },
  },
  mounted() {
    this.fetchAsignacionEquipoByPersonal(this.id)
  },
  methods: {
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    openListadoEquiposAsignadosDialog(item) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.LISTADO_EQUIPOS_ASIGNADOS,
        props: {
          asignacionEquipo: item,
        },
      })
    },
  },
}
</script>
